import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SegmentId = Brand<string, 'SegmentId'>;
export const SegmentId = createBranded<SegmentId>();
